import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { ContextView } from '../../../base/browser/ui/contextview/contextview.js';
import { Disposable, toDisposable } from '../../../base/common/lifecycle.js';
import { ILayoutService } from '../../layout/browser/layoutService.js';

var ContextViewService = /*#__PURE__*/function (_Disposable) {
  _inherits(ContextViewService, _Disposable);

  var _super = _createSuper(ContextViewService);

  function ContextViewService(layoutService) {
    var _this;

    _classCallCheck(this, ContextViewService);

    _this = _super.call(this);
    _this.layoutService = layoutService;
    _this.currentViewDisposable = Disposable.None;
    _this.container = layoutService.container;
    _this.contextView = _this._register(new ContextView(_this.container, 1
    /* ABSOLUTE */
    ));

    _this.layout();

    _this._register(layoutService.onLayout(function () {
      return _this.layout();
    }));

    return _this;
  } // ContextView


  _createClass(ContextViewService, [{
    key: "setContainer",
    value: function setContainer(container, domPosition) {
      this.contextView.setContainer(container, domPosition || 1
      /* ABSOLUTE */
      );
    }
  }, {
    key: "showContextView",
    value: function showContextView(delegate, container, shadowRoot) {
      var _this2 = this;

      if (container) {
        if (container !== this.container) {
          this.container = container;
          this.setContainer(container, shadowRoot ? 3
          /* FIXED_SHADOW */
          : 2
          /* FIXED */
          );
        }
      } else {
        if (this.container !== this.layoutService.container) {
          this.container = this.layoutService.container;
          this.setContainer(this.container, 1
          /* ABSOLUTE */
          );
        }
      }

      this.contextView.show(delegate);
      var disposable = toDisposable(function () {
        if (_this2.currentViewDisposable === disposable) {
          _this2.hideContextView();
        }
      });
      this.currentViewDisposable = disposable;
      return disposable;
    }
  }, {
    key: "getContextViewElement",
    value: function getContextViewElement() {
      return this.contextView.getViewElement();
    }
  }, {
    key: "layout",
    value: function layout() {
      this.contextView.layout();
    }
  }, {
    key: "hideContextView",
    value: function hideContextView(data) {
      this.contextView.hide(data);
    }
  }]);

  return ContextViewService;
}(Disposable);

ContextViewService = __decorate([__param(0, ILayoutService)], ContextViewService);
export { ContextViewService };